import { render, staticRenderFns } from "./IconError.vue?vue&type=template&id=59048081"
import script from "./IconError.vue?vue&type=script&lang=js"
export * from "./IconError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports